import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { AdminEnvironmentVariables } from "../../components/admin/AdminEnvironmentVariables";
import { LegalDepositsSynchronize } from "../../components/admin/LegalDepositsSynchronize";
import { ObalkyKnihSync } from "../../components/admin/ObalkyKnihSync";
import styles from "./AdminPage.module.css";
export var AdminPage = function () {
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({ id: "ui-br-agency.pane.title.navigation" }) },
            React.createElement("div", { className: styles.navContainer },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.admin.title" }) },
            React.createElement(AdminEnvironmentVariables, null),
            React.createElement(LegalDepositsSynchronize, null),
            React.createElement(ObalkyKnihSync, null))));
};
